import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onUnmounted, ref, watch } from 'vue';
import { ActionDetectService } from '@/services/exam/actionDetect.service';
import { TrtcService } from '@/services/exam/trtc.service';
import { useService } from '@kaokei/use-vue-service';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var moveElRef = ref(null);
    var actionDetectService = useService(ActionDetectService);
    var trtcService = useService(TrtcService);
    var inputVideo = ref();
    var beginFlag = ref(false);
    watch(function () {
      return trtcService.videoStream;
    }, function (newStream) {
      if (newStream && inputVideo.value) {
        inputVideo.value.srcObject = newStream;
        if (!beginFlag.value) {
          beginFlag.value = true;
          actionDetectService.init(inputVideo.value);
        }
      }
    });
    var onMoveStart = function (ev) {
      var moveEl = moveElRef.value;
      if (moveEl) {
        var clientX = ev.clientX,
          clientY = ev.clientY;
        var _a = moveEl.getBoundingClientRect(),
          left = _a.left,
          top = _a.top,
          width_1 = _a.width,
          height_1 = _a.height;
        var offsetX_1 = clientX - left;
        var offsetY_1 = clientY - top;
        moveEl.style.left = "".concat(left, "px");
        moveEl.style.top = "".concat(top, "px");
        var onMove_1 = function (moveEv) {
          var moveX = moveEv.clientX,
            moveY = moveEv.clientY;
          // 获取页面宽高
          var pageWidth = document.documentElement.clientWidth;
          var pageHeight = document.documentElement.clientHeight;
          // 计算新的位置
          var newLeft = moveX - offsetX_1;
          var newTop = moveY - offsetY_1;
          // 限制元素不能超出页面边界
          var limitLenW = width_1 - 10;
          var limitLenH = height_1 - 10;
          newLeft = Math.max(limitLenW - width_1, Math.min(pageWidth - limitLenW, newLeft));
          newTop = Math.max(limitLenH - height_1, Math.min(pageHeight - limitLenH, newTop));
          moveEl.style.left = "".concat(newLeft, "px");
          moveEl.style.top = "".concat(newTop, "px");
        };
        var onMoveEnd_1 = function () {
          document.removeEventListener('mousemove', onMove_1);
          document.removeEventListener('mouseup', onMoveEnd_1);
        };
        document.addEventListener('mousemove', onMove_1);
        document.addEventListener('mouseup', onMoveEnd_1);
      }
    };
    onUnmounted(function () {
      actionDetectService.destroy();
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: "ai-detect-area",
        ref: function (_value, _refs) {
          _refs['moveElRef'] = _value;
          moveElRef.value = _value;
        },
        onMousedown: onMoveStart
      }, [_createElementVNode("video", {
        ref: function (_value, _refs) {
          _refs['inputVideo'] = _value;
          inputVideo.value = _value;
        },
        autoPlay: "",
        muted: ""
      }, null, 512)], 544);
    };
  }
});